import { CONSTANTS_GENERATION__slider_step } from '@shared/constants/CONSTANTS_GENERATION__slider_step';
import { CONSTANTS_GENERATION__value_range } from '@shared/constants/CONSTANTS_GENERATION__value_range';
import { ENUM__dto_class_name } from '@shared/serialization/ENUM__dto_class_name';
import { ENUM__field_graph_interaction } from '../../_fields/_base/_enums/ENUM__field_graph_interaction';
import { FIELD_PRIMITIVE__float } from '../../_fields/_primitives/number/FIELD_PRIMITIVE__float';
import { ENUM__image_asset_category } from '../../_fields/ENUM__image_asset_category';
import { FIELD__image_asset } from '../../_fields/image/FIELD__image_asset';
import { ENUM__field_role } from '../_base/ENUM__field_role';
import { ENUM__invocation_type } from '../_base/ENUM__invocation_type';
import { INVOCATION__base } from '../_base/INVOCATION__base';

export class INVOCATION_IMAGE__trim_color extends INVOCATION__base {
  /*
   * STATIC FIELDS
   */
  static _class_name_static: string = ENUM__dto_class_name.INVOCATION_IMAGE__TRIM_COLOR;

  /*
   *
   */

  /*
   *
   */

  @FIELD__image_asset.init_as_input_transform_none(
    { category: ENUM__image_asset_category.IMAGE },
    { graph__interaction: ENUM__field_graph_interaction.VISIBLE_CONNECTABLE },
  )
  image!: FIELD__image_asset;

  // "0.0 requires an exact border color match. "
  // "Higher values allow color variation."
  @FIELD_PRIMITIVE__float.init_as_input(
    {
      value: 0.1,
      value_range: CONSTANTS_GENERATION__value_range.ZERO_TO_ONE,
      values_allowed: CONSTANTS_GENERATION__value_range.ZERO_TO_ONE,
      //
      slider_step: CONSTANTS_GENERATION__slider_step.WEIGHT_DEFAULT,
      slider_step_values: CONSTANTS_GENERATION__slider_step.WEIGHT_VALUES,
    },
    { field_role: ENUM__field_role.NUMBER__THRESHOLD_COLOR },
  )
  threshold!: FIELD_PRIMITIVE__float;

  /*
   *
   */
  @FIELD__image_asset.init_as_output({ category: ENUM__image_asset_category.IMAGE })
  out!: FIELD__image_asset;

  constructor() {
    super(ENUM__invocation_type.IMAGE__TRIM_COLOR);
  }
}
